<template>
  <!-- <div class="row">
    <div class="col-md-auto ml-md-auto"></div>
  </div>
  <div class="demo">
    <table class="table table-sm m-0 tableClaim">
      <thead class="bg-primary-400">
        <tr>
          <th class="fixhead headClaim cwC_1">項目</th>
          <th class="fixhead headClaim cwC_2">数量</th>
          <th class="fixhead headClaim cwC_25">単位</th>
          <th class="fixhead headClaim cwC_3">単価</th>
          <th class="fixhead headClaim cwC_4">金額</th>
          <th class="fixhead headClaim cwC_5">消費税</th>
          <th class="fixhead headClaim cwC_6">税込金額</th>
          <th class="fixhead headClaim cwC_7">備考</th>
        </tr>
      </thead>
      <tbody>
        <Mo_claimlist_row
          v-for="item in items"
          :key="item.c_claim_rownum!"
          v-bind:item="item"
          @reCalc="sumCalc()"
        ></Mo_claimlist_row>
      </tbody>
    </table>
  </div> -->
  <div class="card">
    <div class="card-header">
      <!-- <a
        class="card-title bg-success-600 text-white"
        data-toggle="collapse"
        data-target="#js_demo_accordion-2a"
        aria-expanded="true"
      > -->

      <span class="card-title bg-success-600 text-white" style="padding: 8px">
        <!-- <a v-bind:href="'/dailyReportEdit?id=' + item.c_report_id"> -->
        <button
          type="button"
          class="btn btn-sm btn-primary waves-effect waves-themed mr-1 btn-det"
          @click="goTo('/dailyReportEdit?id=' + item.c_report_id, $event)"
        >
          詳細
        </button>
        <!-- </a> -->
        {{ item.c_report_date_str }}　{{ item.c_staff_name }}
      </span>

      <!-- </a> -->
    </div>
    <div
      id="js_demo_accordion-2a"
      class="collapse show"
      data-parent="#js_demo_accordion-2"
    >
      <div class="card-body">
        <div id="tableflame">
          <table
            class="table table-sm table-bordered m-0"
            id="tableDailyReport"
          >
            <thead>
              <tr>
                <th class="cwC_1">種別<br />（決定、提案、調査）</th>
                <th class="cwC_2">案件名</th>
                <th class="cwC_3">商談先</th>
                <th class="cwC_4">場所</th>
                <th class="cwC_5">内容</th>
                <th class="cwC_6">売上</th>
                <th class="cwC_7">仕入</th>
              </tr>
            </thead>
            <tbody>
              <Mo_tableReportList_det
                v-for="row in item.c_report_det_row"
                :key="row.c_report_det_rownum!"
                v-bind:item="row"
              ></Mo_tableReportList_det>
              <!-- <tr>
              <td class="reportCont">提案</td>
              <td class="reportCont">ダイアパレス一宮</td>
              <td class="reportCont">ダイア建設名古屋</td>
              <td class="reportCont">名古屋市中区</td>
              <td>「〇〇建植広告」,「□□ビル屋上広告」媒体資料提出</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td class="reportCont">提案</td>
              <td class="reportCont">ヤマザキマザック</td>
              <td class="reportCont">リード名古屋営業所</td>
              <td class="reportCont">社内　メールにて</td>
              <td>
                「ヤマザキマザック本社ビル敷地内建植広告改修工事：300万円」見積書提出
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td class="reportCont">決定</td>
              <td class="reportCont">ネクステージ名東店</td>
              <td class="reportCont">同広報担当：〇〇氏</td>
              <td class="reportCont">社内　メールにて</td>
              <td>
                「△△ビル壁面広告」掲出料60万円／年（税別）製作施工費120万円（税別）
              </td>
              <td>x,xxx,xxx</td>
              <td>x,xxx,xxx</td>
            </tr>
            <tr>
              <td class="reportCont">調査</td>
              <td class="reportCont">三浦歯科</td>
              <td class="reportCont">田中 康夫</td>
              <td class="reportCont">名古屋市名東区一社2-5-19</td>
              <td>
                H1,800mm×W2,700mm GL2,000mm 建植広告　150,000円／年（税別）承諾
              </td>
              <td></td>
              <td></td>
            </tr> -->
            </tbody>
          </table>
        </div>
        <div>
          <textarea
            name="txtComment"
            class="form-control txtComment"
            disabled
            v-model="item.cnvRemarks"
          ></textarea>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Prop, Options, Vue } from "vue-property-decorator";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { EntityClaimDet } from "furukawa-common/src/common/entity/EntityClaimDet";
import Mo_tableReportList_det from "../molecules/Mo_tableReportList_det.vue";
import { EntityReportImple } from "furukawa-common/src/common/entity/EntityReportImple";
import { commonDateFurukawa } from "furukawa-common/src/common/function/commonDateFurukawa";
import { Cl_common } from "@/functions/Cl_common";

@Options({
  components: {
    vSelect,
    Mo_tableReportList_det,
  },
})
export default class Or_tableReportList extends Vue {
  /**
   * パフォーマンス問題の解決案としてテスト的に実装中
   * 残課題：グローバルなメソッドとして宣言して、どこからでも呼び出せるようにしたい
   * 　　　　色々なパターンでも問題ないかの検証
   * @param url
   * @param event
   */
  goTo(url: string, event?: MouseEvent) {
    if (event && (event.ctrlKey || event.metaKey)) {
      window.open(url);
    } else {
      this.$router.push(url);
    }
  }
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  @Prop({ required: true })
  item: EntityReportImple;

  domDate = "";
  domRemarks = "";

  btnDisable = false;

  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  //----------------------
  //モーダル用プロパティ
  //----------------------
  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    // await this.AdjData();
  }

  async AdjData() {
    // this.domRemarks = this.item.c_report_remarks!;
    // this.domDate = commonDateFurukawa.formatDateString(
    //   this.item.c_report_date!
    // );
  }

  /**
   * buttonの有効無効を制御
   */
  eventAdjButton(btnDisableTmp: boolean) {
    this.btnDisable = btnDisableTmp;
  }

  async move() {
    await this.$router.push("/dailyReportEdit?id=" + this.item.c_report_id);
  }
  //----------------------
  //基本操作用メソッド
  //----------------------

  //----------------------
  //モーダル用メソッド
  //----------------------
}
</script>
<style scoped>
thead > tr {
  border: 1px solid #7289aa;
}
input:disabled {
  background-color: #fff;
}
.headClaim {
  text-align: center;
}
.tableClaim tbody tr {
  border-bottom: 1px solid #ccc;
}

.tableClaim td {
  border-right: 1px solid #ccc;
}
.tableClaim tr > td:last-child {
  border-right: none;
}

.table-sm th {
  text-align: center;
}

.cwC_1 {
  min-width: 100px;
}
.cwC_2 {
  min-width: 110px;
}
.cwC_3 {
  min-width: 110px;
}
.cwC_4 {
  min-width: 110px;
}
.cwC_5 {
  min-width: 360px;
}
.cwC_6 {
  min-width: 70px;
}
.cwC_7 {
  min-width: 70px;
}

.tableClaim tr:hover td > input,
.tableClaim tr:hover td > select,
.tableClaim tr:hover td {
  background-color: #dddddd;
}

.btn-det {
  margin-right: 30px !important;
}

#tableflame {
  width: 100%;
  overflow-x: auto;
}
#tableDailyReport {
  width: 99%;
  margin: 0 auto !important;
}
.txtComment {
  width: 99%;
  margin: 0 auto;
}
</style>
